import { useContext, useEffect, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import DashboardContext from "Context";
import InputControlAsyncMultiBulk from "components/inputs/InputControlAsyncMultiBulk";
import Axios from "axios"
import { Divider } from "antd";
import toaster from "helper/toaster";

export default function FavoritelistCustomer() {

    const { handelFromTabel, urldashboard, authentication, handelerrors, setOnSearchLoading, setOffSearchLoding, searchLoading } = useContext(DashboardContext)
    const [customerFavoriteList, setCustomerFavoriteList] = useState([]);
    const [formData, setFormData] = useState({ userId: JSON.parse(sessionStorage.getItem('customerid')) })

    useEffect(() => {
        handelFromTabel({ userId: JSON.parse(sessionStorage.getItem('customerid')) });
        fetchFavoriteListOfCustomer();
        return () => { };
    }, []);

    const fetchFavoriteListOfCustomer = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/customer/getFavoriteListWorkers/${formData?.userId}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data.data;
            setCustomerFavoriteList(data);
        } catch (error) {
            handelerrors(error);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setOnSearchLoading();

        var command = {
            favoriteListWorkerIds: formData?.favoriteListWorkerIds !== undefined ? formData?.favoriteListWorkerIds : customerFavoriteList?.map(x => x?.value),
            userId: formData?.userId
        };

        try {
            const res = await Axios.post(`${urldashboard}/customer/setFavoriteListWorkers`, JSON.stringify(command), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            });
            setOffSearchLoding();
            toaster.success(res?.data?.message);
        } catch (error) {
            handelerrors(error);
        }
        handelFromTabel(command);
    };

    return (
        <>
            <Form>
                <Form.Row>
                    <Divider>{'برای مشتری'}</Divider>
                    <Col>
                        <InputControlAsyncMultiBulk
                            url='/worker/bulksearch'
                            label='لیست نیروها'
                            name='favoriteListWorkerIds'
                            isDefaultValue={true}
                            idSelect={customerFavoriteList}
                            handelValue={(_, value) => {
                                value !== null && value !== undefined && value?.length > 0 ?
                                    setFormData({ ...formData, favoriteListWorkerIds: value }) : setCustomerFavoriteList([]);
                            }}
                            defaultValue={customerFavoriteList}
                        />
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col className='d-flex'>
                        <Button onClick={handleSubmit} variant='success'>
                            {searchLoading ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : "ذخیره"}
                        </Button>
                    </Col>
                </Form.Row>
            </Form>
        </>
    )
}
